import React from 'react';
import styled from 'styled-components';
export default function FormHeader({ children, className, }) {
    return (React.createElement(StyledFormHeader, { className: className }, children));
}
const StyledFormHeader = styled.div `
  display: inline-block;
`;
